import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import isEmpty from 'lodash.isempty';
import SectionLoader from '../../components/Loader/SectionLoader';
import {
  getCurrentAccountUid,
  selectAccounts,
} from '../../store/selectors/accountSelectors';
import { fetchAccountAgreement } from '../../store/actions/account/accountActions';
import { retrieveFromLocalStorage } from '../../util/helpers/localStorageHelper';
import { AGREEMENT_TYPE } from '../../constants/localStorage';
import { parseEnumType } from '../../util/helpers/enumMappers';
import { accountTypeKeys } from '../../util/enum/api/accountTypes';
// import useGtmHook from '../../util/hooks/useGtmHook';
// import { APPLICATION_TERMS_VIEWED } from '../../constants/gtmEvents';

const PdfDisplay = styled.iframe`
  width: 100vw;
  height: 100vh;
`;

const TermsPage = () => {
  const dispatch = useDispatch();
  // const { gtmEvent } = useGtmHook();
  const accountUid = useSelector(getCurrentAccountUid);
  const allAccounts = useSelector(selectAccounts);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const agreementFetchSuccess = (data) => {
    if (data) {
      const objectUrl = URL.createObjectURL(data);
      setPdfUrl(objectUrl);
    }
  };

  useEffect(() => {
    if (allAccounts && !isEmpty(allAccounts)) {
      const agreementType = retrieveFromLocalStorage(AGREEMENT_TYPE);
      let iraAccountUid = '';
      if (agreementType === 'IRA') {
        const iraAccount = allAccounts?.find(
          (account) =>
            parseEnumType(accountTypeKeys, account?.AccountType) === 'IRA',
        );

        if (iraAccount && !isEmpty(iraAccount)) {
          iraAccountUid = iraAccount?.AccountUid;
        }
      }

      // gtmEvent(APPLICATION_TERMS_VIEWED, {
      //   eventLabel: 'registration',
      //   gtm: {
      //     uniqueEventId: 33,
      //   },
      // });

      dispatch(
        fetchAccountAgreement({
          accountUid: iraAccountUid || accountUid,
          agreementType,
          agreementFetchSuccess,
          setIsLoading,
        }),
      );
    }
  }, [accountUid, allAccounts, dispatch]);
  return (
    <SectionLoader isLoading={isLoading}>
      <PdfDisplay src={pdfUrl} />
    </SectionLoader>
  );
};

TermsPage.propTypes = {};

export default TermsPage;
